import { render, staticRenderFns } from "./FaceTalk.vue?vue&type=template&id=5233b928"
import script from "./FaceTalk.vue?vue&type=script&lang=js"
export * from "./FaceTalk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports